import {
  formatDateBRInBrasilia,
  toDateKeyInBrasilia,
  toDateOnlyTimestampInBrasilia,
} from "./dateBrasilia";

export function isLedgerDebitEntry(entry) {
  const origin = String(entry?.origin || "").trim().toUpperCase();
  const entryType = String(entry?.entry_type || "").trim().toUpperCase();

  return origin === "WITHDRAW" || entryType === "DEBIT";
}

export function getLedgerStatementDateValue(entry) {
  if (!entry) return "";

  if (isLedgerDebitEntry(entry)) {
    return entry.entry_date || entry.purchase_date || entry.created_at || "";
  }

  return entry.entry_date || entry.purchase_date || entry.created_at || "";
}

export function getLedgerStatementDateKey(entry) {
  return toDateKeyInBrasilia(getLedgerStatementDateValue(entry));
}

export function getLedgerStatementTimestamp(entry) {
  return toDateOnlyTimestampInBrasilia(getLedgerStatementDateValue(entry));
}

export function formatLedgerStatementDate(entry, fallback = "-") {
  return formatDateBRInBrasilia(getLedgerStatementDateValue(entry), fallback);
}
